import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'frontPage',
    meta: {
      title: '列表查詢|新北即時交通資訊網',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '@/views/FrontPage.vue')
  },
  {
    path: '/busMsg',
    name: 'BusPage',
    meta: {
      title: '列表查詢公車資訊|新北即時交通資訊網',
    },
    component: () => import( /* webpackChunkName: "about" */ '@/views/BusPage.vue')
  },
  {
    path: '/cmsMsg',
    name: 'CmsPage',
    meta: {
      title: '列表查詢CMS資訊|新北即時交通資訊網',
    },
    component: () => import( /* webpackChunkName: "about" */ '@/views/CmsPage.vue')
  },
  // {
  //   path: '/constrMsg',
  //   name: 'ConstrPage',
  //   meta: {
  //     title: '列表查詢施工資訊|新北即時交通資訊網',
  //   },
  //   component: () => import( /* webpackChunkName: "about" */ '@/views/ConstrPage.vue')
  // },
  {
    path: '/announceMsg',
    name: 'AnnouncePage',
    meta: {
      title: '列表查詢即時公告|新北即時交通資訊網',
    },
    component: () => import( /* webpackChunkName: "about" */ '@/views/AnnouncePage.vue')
  },
  {
    path: '/aboutMe',
    name: 'AboutMePage',
    meta: {
      title: '關於我們|新北即時交通資訊網',
    },
    component: () => import( /* webpackChunkName: "about" */ '@/views/AboutMePage.vue')
  },
  {
    path: '/siteMap',
    name: 'SiteMapPage',
    meta: {
      title: '網路地圖|新北即時交通資訊網',
    },
    component: () => import( /* webpackChunkName: "about" */ '@/views/SiteMapPage.vue')
  },
  {
    path: '/ubikeMsg',
    name: 'UbikePage',
    meta: {
      title: '列表查詢Yubike資訊|新北即時交通資訊網',
    },
    component: () => import( /* webpackChunkName: "about" */ '@/views/UbikePage.vue')
  },
  {
    path: '/parkingMsg',
    name: 'ParkingPage',
    meta: {
      title: '列表查詢停車場資訊|新北即時交通資訊網',
    },
    component: () => import( /* webpackChunkName: "about" */ '@/views/ParkingPage.vue')
  },
  {
    path: '*',
    redirect: '/',
  }
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

export default router